var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"entry"},[_c('Header',{on:{"clickBack":_vm.clickBack}}),_c('div',{staticClass:"container"},[_c('EntryButtons',{on:{"clickPhoneSignUp":function($event){return _vm.$emit('clickPhoneSignUp', 'agree')},"kakaoSignUp":_vm.kakaoSignUp,"kakaoSignIn":_vm.kakaoSignIn}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }